var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"left-sidebar"},[_c('LeftNews')],1),_c('div',{staticClass:"main-content"},[_c('router-view')],1),_c('div',{staticClass:"right-sidebar"},[_c('RightNews')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }